import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import LiteratureMonoHtmlView from './LiteratureHtml';
import LiteratureMonoReactView from './Literature';
const LiterartureMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(LiteratureMonoHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(LiteratureMonoReactView, _extends({}, props));
};
LiterartureMonoView.displayName = 'LiterartureMonoView';
export default LiterartureMonoView;
